import React from 'react';
import { connect } from 'react-redux';

import { getWorkflowConstants } from '~/common/constants/workflow';
import { Tooltip } from '~/eds/src/components/Tooltip/Tooltip';
import { useIntl } from 'react-intl';
import { getFieldDefinitionStatus, testDocumentField } from '~/utils/workflow';

import RadioItem from './RadioItem';

function RadioSigners({
  field,
  selectedFieldDefinition,
  onClick,
  onShowMore,
  // connected
  fieldLinks,
}) {
  const intl = useIntl();
  const { signerFieldDefinitions } = getWorkflowConstants(intl);

  return (
    <>
      {signerFieldDefinitions.map((fieldDefinition) => {
        const { isSelected } = getFieldDefinitionStatus({
          fieldDefinition,
          fieldLinks,
          selectedFieldDefinition,
          intl,
        });
        const disabledTooltip =
          field &&
          !testDocumentField(field) &&
          fieldDefinition.key === 'signature'
            ? intl.formatMessage({
                id: 'RadioSigners.cannotAssignCustomFields',
                defaultMessage:
                  'Cannot assign custom fields to the signature field',
                description:
                  'Tooltip message when custom fields cannot be assigned to signature field',
              })
            : undefined;
        return (
          <Tooltip tooltip={disabledTooltip} id={fieldDefinition.key}>
            <RadioItem
              disabled={disabledTooltip}
              option={{
                label: fieldDefinition.label,
                value: fieldDefinition.key,
              }}
              selected={isSelected}
              onClick={() => {
                onClick(fieldDefinition);
                onShowMore();
              }}
              onShowMore={onShowMore}
            />
          </Tooltip>
        );
      })}
    </>
  );
}

const mapStateToProps = ({ workflow }) => ({
  fieldLinks: workflow.fieldLinks,
});

export default connect(mapStateToProps)(RadioSigners);
